class DateUtil {
  formatDateToLocaleString(date: Date | null) {
    if (!date) return "N/A";
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  }
}

export default new DateUtil();
